import {FileSelectProps} from '../components/file-select';

export const getFileSelect =
  <T>(data: Omit<FileSelectProps<T>, 'type'>) =>
  (): FileSelectProps<T> => ({
    ...data,
    type: 'file-select',
  });
